import { Transform } from 'class-transformer';
import { ArrayMaxSize, ArrayMinSize, IsArray, IsString, IsUUID } from 'class-validator';
import { splitCommaSeparatedIds } from '../common/comma-separated-ids.transform';

/** Tetto di record per una singola chiamata batch degli allegati di autocontrollo. */
export const SELF_CHECK_ATTACHMENTS_BY_SOURCES_MAX_IDS = 100;

/**
 * Query di `GET /self-check-attachments/by-sources?sourceType=…&sourceIds=a,b`.
 * `sourceType` resta una stringa: lo valida il controller con `validateEnum`,
 * come `GET /self-check-attachments`.
 */
export class SelfCheckAttachmentsBySourcesQueryDto {
  @IsString()
  sourceType!: string;

  @Transform(({ value }) => splitCommaSeparatedIds(value))
  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(SELF_CHECK_ATTACHMENTS_BY_SOURCES_MAX_IDS)
  @IsUUID('all', { each: true })
  sourceIds!: string[];
}
